import { Row, Col, Text } from "@/base/components/index";
import { useFieldDisplayStyles } from "./field-display.styles";
import { FieldDisplayProps } from "../types/index";
import { useMemo } from "react";

export const FieldDisplay = ({
  label,
  value,
  layout = "auto",
}: FieldDisplayProps) => {
  const { styles } = useFieldDisplayStyles();

  const colLabelConfig = useMemo(() => {
    if (layout === "horizontal") {
      return { span: 8 };
    }
    if (layout === "vertical") {
      return { span: 24 };
    }
    return { xs: { span: 24 }, md: { span: 8 } };
  }, [layout]);

  const colValueConfig = useMemo(() => {
    if (layout === "horizontal") {
      return { span: 16 };
    }
    if (layout === "vertical") {
      return { span: 24 };
    }
    return { xs: { span: 24 }, md: { span: 16 } };
  }, [layout]);

  return (
    <Row gutter={[12, 4]} className={styles.root}>
      <Col {...colLabelConfig}>
        <Text strong>{label}</Text>
      </Col>
      <Col {...colValueConfig}>
        {typeof value === "string" ? <Text>{value}</Text> : value}
      </Col>
    </Row>
  );
};
